import { useState, useEffect } from "react";
import "../index.css";
import { useNavigate } from "react-router-dom";
import ApiCall from "../auth/ApiCall";
import { WEB_URL } from "../auth/types";
import type { SubscriptionPlan } from "../types/planTypes";
import { plans } from "../types/planTypes";
import buttonBackground from "../assets/button_background_blue.webp";
import { useAuth } from "../auth/context";
import { auth } from "../auth/firebase";

// interface SubscriptionPlan {
//   idMonthly: string;
//   idAnnual: string;
//   nameMonthly: string;
//   nameAnnual: string;
//   priceMonthly: number;
//   priceAnnual: number;
//   //   interval: "month" | "year";
//   features: string[];
//   stripePriceIdMonthly: string;
//   stripePriceIdAnnual: string;
//   popular?: boolean;
// }

export default function Subscribe() {
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [showMonthly, setShowMonthly] = useState<boolean>(false);
  const isNewUser = localStorage.getItem("state_id") === "1";
  const hasDiscount = localStorage.getItem("has_discount") === "true";
  const DISCOUNT_RATE = 0.2;
  const discountedPrice = (price: number) =>
    hasDiscount ? (price * (1 - DISCOUNT_RATE)).toFixed(2) : null;
  const [existingPlatform, setExistingPlatform] = useState<string | null>(null);
  const [managementUrl, setManagementUrl] = useState<string>("");
  const [checkingSubscription, setCheckingSubscription] =
    useState<boolean>(true);

  // Check for existing subscription on component mount
  useEffect(() => {
    const checkExistingSubscription = async () => {
      try {
        const response = (await ApiCall.makeAuthenticatedRequest(
          "/accounts/api/payments/subscription/management-info/",
        )) as {
          can_manage_in_app?: boolean;
          platform_name?: string;
          management_url?: string;
          has_active_subscription?: boolean;
        };

        // If user has an active subscription from a mobile platform, prevent web signup
        if (
          response.can_manage_in_app === false &&
          response.platform_name &&
          response.has_active_subscription
        ) {
          setExistingPlatform(response.platform_name);
          setManagementUrl(response.management_url || "");
        }
      } catch {
        // console.error("Failed to check subscription status:", err);
        // Don't block signup if check fails - user might be new
      } finally {
        setCheckingSubscription(false);
      }
    };

    checkExistingSubscription();
  }, []);

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Define your subscription plans
  // const plans: SubscriptionPlan[] = [
  //   {
  //     idMonthly: "basic_monthly",
  //     idAnnual: "basic_annual",
  //     nameMonthly: "Basic",
  //     nameAnnual: "Basic",
  //     priceMonthly: 9.99,
  //     priceAnnual: 99.99,
  //     //   interval: "month",
  //     stripePriceIdMonthly: "price_1SSHn9Dp8jvphDnHZ2A8hcUB", // Replace with your actual Stripe Price ID
  //     stripePriceIdAnnual: "price_1SSHneDp8jvphDnHUAV5oZVQ", // Replace with your actual Stripe Price ID
  //     features: [
  //       "Access to basic features",
  //       "Email support",
  //       "Limited alerts",
  //       "Mobile app access",
  //     ],
  //   },
  //   {
  //     idMonthly: "pro_monthly",
  //     idAnnual: "pro_annual",
  //     nameMonthly: "Pro",
  //     nameAnnual: "Pro",
  //     priceMonthly: 19.99,
  //     priceAnnual: 199.99,
  //     //   interval: "month",
  //     stripePriceIdMonthly: "price_1SSHoADp8jvphDnHqPcWUdeh", // Replace with your actual Stripe Price ID
  //     stripePriceIdAnnual: "price_1SSHodDp8jvphDnHnWGzjayU", // Replace with your actual Stripe Price ID
  //     features: [
  //       "All Basic features",
  //       "Unlimited alerts",
  //       "Priority support",
  //       "Advanced analytics",
  //       "Custom notifications",
  //     ],
  //     popular: true,
  //   },
  //   {
  //     idMonthly: "premium_monthly",
  //     idAnnual: "premiun_annual",
  //     nameMonthly: "Premium",
  //     nameAnnual: "Premium",
  //     priceMonthly: 24.99,
  //     priceAnnual: 249.99,
  //     //   interval: "month",
  //     stripePriceIdMonthly: "price_1SSHp0Dp8jvphDnHRexFM2Oz", // Replace with your actual Stripe Price ID
  //     stripePriceIdAnnual: "price_1SSHpMDp8jvphDnHk52K3Kl7", // Replace with your actual Stripe Price ID
  //     features: [
  //       "All Pro features",
  //       "Save 2 months",
  //       "Dedicated support",
  //       "Early access to new features",
  //       "Custom integrations",
  //     ],
  //   },
  //   // {
  //   //   id: "basic_annual",
  //   //   name: "Basic Annual",
  //   //   price: 99.99,
  //   //   interval: "year",
  //   //   stripePriceId: "price_basic_annual", // Replace with your actual Stripe Price ID
  //   //   features: [
  //   //     "Access to basic features",
  //   //     "Email support",
  //   //     "Limited alerts",
  //   //     "Mobile app access",
  //   //   ],
  //   // },
  //   // {
  //   //   id: "pro_monthly",
  //   //   name: "Pro Monthly",
  //   //   price: 19.99,
  //   //   interval: "month",
  //   //   stripePriceId: "price_pro_monthly", // Replace with your actual Stripe Price ID
  //   //   popular: true,
  //   //   features: [
  //   //     "All Basic features",
  //   //     "Unlimited alerts",
  //   //     "Priority support",
  //   //     "Advanced analytics",
  //   //     "Custom notifications",
  //   //   ],
  //   // },
  //   // {
  //   //   id: "pro_annual",
  //   //   name: "Pro Annual",
  //   //   price: 199.99,
  //   //   interval: "year",
  //   //   stripePriceId: "price_pro_annual", // Replace with your actual Stripe Price ID
  //   //   popular: true,
  //   //   features: [
  //   //     "All Basic features",
  //   //     "Unlimited alerts",
  //   //     "Priority support",
  //   //     "Advanced analytics",
  //   //     "Custom notifications",
  //   //   ],
  //   // },
  //   // {
  //   //   id: "premium_monthly",
  //   //   name: "Premium Monthly",
  //   //   price: 24.99,
  //   //   interval: "month",
  //   //   stripePriceId: "price_premium_monthly", // Replace with your actual Stripe Price ID
  //   //   features: [
  //   //     "All Pro features",
  //   //     "Save 2 months",
  //   //     "Dedicated support",
  //   //     "Early access to new features",
  //   //     "Custom integrations",
  //   //   ],
  //   // },
  //   // {
  //   //   id: "premium_annual",
  //   //   name: "Premium Annual",
  //   //   price: 249.99,
  //   //   interval: "year",
  //   //   stripePriceId: "price_premium_annual", // Replace with your actual Stripe Price ID
  //   //   features: [
  //   //     "All Pro features",
  //   //     "Save 2 months",
  //   //     "Dedicated support",
  //   //     "Early access to new features",
  //   //     "Custom integrations",
  //   //   ],
  //   // },
  // ];

  const ensureProfileExists = async (): Promise<void> => {
    const firebaseUser = auth.currentUser;
    if (!firebaseUser) return;
    const providerIds = firebaseUser.providerData.map((p) => p.providerId);
    const provider = providerIds.includes("google.com")
      ? "google"
      : providerIds.includes("apple.com")
        ? "apple"
        : "email";
    await ApiCall.makeAuthenticatedRequest("/accounts/api/user/profile/create/", {
      method: "POST",
      body: JSON.stringify({ provider }),
    }).catch(() => {});
  };

  const handleSubscribe = async (plan: SubscriptionPlan) => {
    setError("");
    setIsLoading(true);
    setSelectedPlan(showMonthly ? plan.idMonthly : plan.idAnnual);

    try {
      let customerResponse = await ApiCall.makeAuthenticatedRequest(
        "/accounts/api/payments/stripe/create-customer/",
        { method: "POST" },
      );

      // If the backend can't find the UserProfile, attempt to create it then retry once
      if (customerResponse.error && (customerResponse.statusCode as number) >= 500) {
        await ensureProfileExists();
        customerResponse = await ApiCall.makeAuthenticatedRequest(
          "/accounts/api/payments/stripe/create-customer/",
          { method: "POST" },
        );
      }

      if (customerResponse.error) {
        const isServerError = (customerResponse.statusCode as number) >= 500;
        throw new Error(
          isServerError
            ? "We had trouble setting up your account. Please sign out and sign back in, then try again."
            : (customerResponse.error as string),
        );
      }

      const checkoutResponse = await ApiCall.makeAuthenticatedRequest(
        "/accounts/api/payments/stripe/create-checkout/",
        {
          method: "POST",
          body: JSON.stringify({
            price_id: showMonthly
              ? plan.stripePriceIdMonthly
              : plan.stripePriceIdAnnual,
            success_url: WEB_URL + "/games",
            cancel_url: WEB_URL + "/subscribe",
          }),
        },
      );

      if (checkoutResponse.error) {
        throw new Error(checkoutResponse.error as string);
      }

      const redirectUrl =
        (checkoutResponse.url as string) ||
        (checkoutResponse.session_url as string);
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        throw new Error("Failed to get checkout URL. Please try again.");
      }
    } catch (err) {
      // console.error("Subscription error:", err);

      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Failed to start checkout. Please try again.");
      }

      setIsLoading(false);
      setSelectedPlan(null);
    }
  };

  const displayMonthly = () => {
    setShowMonthly(true);
  };

  const displayYearly = () => {
    setShowMonthly(false);
  };

  const handleLogout = async (): Promise<void> => {
    try {
      await logout();
      navigate("/");
    } catch {
      // console.error("Logout failed:", error);
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-overlay-spinner"></div>
        </div>
      )}
      {/* <PageNav /> */}
      <div className="" style={{ paddingTop: 20, paddingBottom: 40 }}>
        <div className="center_me">
          <h1
            className="font_family_base"
            style={{ fontSize: 32, marginBottom: 10 }}
          >
            Choose Your Plan
          </h1>
          {/* <p
            className="font_family_base"
            style={{ color: "#666", marginBottom: 40 }}
          >
            Select the perfect plan for your needs
          </p> */}
        </div>

        {/* Platform Notice - Show if user has existing mobile subscription */}
        {!checkingSubscription && existingPlatform && (
          <div
            className="center_me"
            style={{
              backgroundColor: "#fff3e0",
              color: "#e65100",
              padding: "20px",
              borderRadius: "8px",
              marginBottom: "30px",
              maxWidth: "700px",
              margin: "0 auto 30px auto",
              border: "2px solid #ff9800",
            }}
          >
            <p
              className="font_family_base"
              style={{
                margin: 0,
                fontSize: 16,
                fontWeight: "bold",
                marginBottom: 10,
              }}
            >
              ⚠️ Existing Subscription Detected
            </p>
            <p
              className="font_family_base"
              style={{ margin: 0, fontSize: 14, marginBottom: 15 }}
            >
              You already have an active subscription through {existingPlatform}
              . To avoid duplicate charges, please manage your subscription
              through your {existingPlatform} account.
            </p>
            {managementUrl && (
              <a
                href={managementUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="font_family_base"
                style={{
                  display: "inline-block",
                  padding: "10px 20px",
                  backgroundColor: "#ff9800",
                  color: "#FFF",
                  borderRadius: "4px",
                  textDecoration: "none",
                  fontSize: 14,
                  fontWeight: "bold",
                }}
              >
                Manage {existingPlatform} Subscription →
              </a>
            )}
          </div>
        )}
        <div className="row center_me margin_bottom_30">
          <button
            id="next_name"
            className={`font_family_base ${
              showMonthly ? "bill-type-button-disabled" : "bill-type-button"
            }`}
            style={{ fontSize: 16 }}
            onClick={displayYearly}
          >
            Paid Yearly
          </button>
          <button
            id="next_name"
            className={`font_family_base ${
              showMonthly ? "bill-type-button" : "bill-type-button-disabled"
            }`}
            style={{ fontSize: 16 }}
            onClick={displayMonthly}
          >
            Paid Monthly
          </button>
        </div>

        {error && (
          <div
            className="center_me"
            style={{
              backgroundColor: "#fee",
              color: "#c33",
              padding: "12px 20px",
              borderRadius: "8px",
              marginBottom: "30px",
              maxWidth: "600px",
              margin: "0 auto 30px auto",
              border: "1px solid #fcc",
            }}
          >
            {error}
          </div>
        )}

        {/* Desktop View */}
        <div className="show-desktop">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "20px",
              maxWidth: "1200px",
              margin: "0 auto",
              padding: "0 20px",
            }}
          >
            {plans.map((plan) => (
              <div
                key={showMonthly ? plan.idMonthly : plan.idAnnual}
                style={{
                  border: plan.popular ? "2px solid #4CAF50" : "1px solid #ccc",
                  borderRadius: "12px",
                  padding: "30px",
                  backgroundColor: "#000",
                  position: "relative",
                  boxShadow: plan.popular
                    ? "0 4px 12px rgba(76, 175, 80, 0.2)"
                    : "0 2px 8px rgba(0,0,0,0.1)",
                  transition: "transform 0.2s",
                  display: "flex",
                  flexDirection: "column",
                  opacity: plan.comingSoon ? 0.6 : 1,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {plan.popular && (
                  <div
                    style={{
                      position: "absolute",
                      top: "-12px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "#4CAF50",
                      color: "white",
                      padding: "4px 16px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                    className="font_family_base"
                  >
                    MOST POPULAR
                  </div>
                )}
                {plan.comingSoon && (
                  <div
                    style={{
                      position: "absolute",
                      top: "-12px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "#666",
                      color: "white",
                      padding: "4px 16px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                    className="font_family_base"
                  >
                    COMING SOON
                  </div>
                )}

                <h2
                  className="font_family_base center_me"
                  style={{ fontSize: 24, marginBottom: 10 }}
                >
                  {showMonthly ? plan.nameMonthly : plan.nameAnnual}
                </h2>

                <div style={{ marginBottom: 20 }}>
                  {hasDiscount && (
                    <span
                      className="font_family_base"
                      style={{
                        fontSize: 20,
                        color: "#AAA",
                        textDecoration: "line-through",
                        marginRight: 8,
                      }}
                    >
                      ${showMonthly ? plan.priceMonthly : plan.priceAnnual}
                    </span>
                  )}
                  <span
                    className="font_family_base"
                    style={{
                      fontSize: 36,
                      fontWeight: "bold",
                      color: hasDiscount ? "#4CAF50" : undefined,
                    }}
                  >
                    $
                    {discountedPrice(
                      showMonthly ? plan.priceMonthly : plan.priceAnnual,
                    ) ?? (showMonthly ? plan.priceMonthly : plan.priceAnnual)}
                  </span>
                  <span
                    className="font_family_base"
                    style={{ color: "#AAA", fontSize: 16 }}
                  >
                    /{showMonthly ? "month" : "year"}
                  </span>
                  {hasDiscount && (
                    <p
                      className="font_family_base"
                      style={{
                        color: "#4CAF50",
                        fontSize: 13,
                        marginTop: 4,
                        marginBottom: 0,
                      }}
                    >
                      20% discount applied
                    </p>
                  )}
                  {isNewUser && (
                    <p
                      className="font_family_base"
                      style={{
                        color: "#4CAF50",
                        fontSize: 18,
                        marginTop: 6,
                        marginBottom: 0,
                      }}
                    >
                      7-day free trial
                    </p>
                  )}
                </div>

                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    marginBottom: 30,
                    minHeight: "180px",
                    flex: 1,
                  }}
                >
                  {plan.features.map((feature, index) => (
                    <li
                      key={index}
                      className="font_family_base"
                      style={{
                        padding: "8px 0",
                        display: "flex",
                        alignItems: "center",
                        fontSize: 14,
                      }}
                    >
                      <span style={{ color: "#4CAF50", marginRight: 8 }}>
                        ✓
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>

                <div className="center_me">
                  <button
                    onClick={() => !plan.comingSoon && handleSubscribe(plan)}
                    disabled={isLoading || !!plan.comingSoon}
                    className="my-form-button-wide button-base button-3d font_family_base"
                    style={{
                      // width: "100%",
                      marginTop: "5px",
                      marginBottom: "5px",
                      backgroundImage: `url(${buttonBackground})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      color: "white",
                      fontWeight: 700,
                      opacity:
                        plan.comingSoon ||
                        (isLoading &&
                          selectedPlan ===
                            (showMonthly ? plan.idMonthly : plan.idAnnual))
                          ? 0.6
                          : 1,
                      cursor: plan.comingSoon ? "default" : "pointer",
                    }}
                  >
                    {plan.comingSoon
                      ? "Coming Soon"
                      : isLoading &&
                          selectedPlan ===
                            (showMonthly ? plan.idMonthly : plan.idAnnual)
                        ? "Processing..."
                        : "Subscribe Now"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile View */}
        <div className="show-mobile" style={{ padding: "0 20px" }}>
          {plans.map((plan) => (
            <div
              key={showMonthly ? plan.idMonthly : plan.idAnnual}
              style={{
                border: plan.popular ? "2px solid #4CAF50" : "1px solid #ccc",
                borderRadius: "12px",
                padding: "24px",
                backgroundColor: "#000",
                marginBottom: "20px",
                position: "relative",
                boxShadow: plan.popular
                  ? "0 4px 12px rgba(76, 175, 80, 0.2)"
                  : "0 2px 8px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                opacity: plan.comingSoon ? 0.6 : 1,
              }}
            >
              {plan.popular && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    padding: "4px 16px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                  className="font_family_base"
                >
                  MOST POPULAR
                </div>
              )}
              {plan.comingSoon && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#666",
                    color: "white",
                    padding: "4px 16px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                  }}
                  className="font_family_base"
                >
                  COMING SOON
                </div>
              )}

              <h2
                className="font_family_base center_me"
                style={{ fontSize: 22, marginBottom: 10 }}
              >
                {showMonthly ? plan.nameMonthly : plan.nameAnnual}
              </h2>

              <div style={{ marginBottom: 16 }}>
                {hasDiscount && (
                  <span
                    className="font_family_base"
                    style={{
                      fontSize: 16,
                      color: "#AAA",
                      textDecoration: "line-through",
                      marginRight: 8,
                    }}
                  >
                    ${showMonthly ? plan.priceMonthly : plan.priceAnnual}
                  </span>
                )}
                <span
                  className="font_family_base"
                  style={{
                    fontSize: 32,
                    fontWeight: "bold",
                    color: hasDiscount ? "#4CAF50" : undefined,
                  }}
                >
                  $
                  {discountedPrice(
                    showMonthly ? plan.priceMonthly : plan.priceAnnual,
                  ) ?? (showMonthly ? plan.priceMonthly : plan.priceAnnual)}
                </span>
                <span
                  className="font_family_base"
                  style={{ color: "#AAA", fontSize: 14 }}
                >
                  {showMonthly ? "/month" : "/year"}
                </span>
                {hasDiscount && (
                  <p
                    className="font_family_base"
                    style={{
                      color: "#4CAF50",
                      fontSize: 12,
                      marginTop: 4,
                      marginBottom: 0,
                    }}
                  >
                    20% discount applied
                  </p>
                )}
                {isNewUser && (
                  <p
                    className="font_family_base"
                    style={{
                      color: "#4CAF50",
                      fontSize: 13,
                      marginTop: 6,
                      marginBottom: 0,
                    }}
                  >
                    7-day free trial
                  </p>
                )}
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  marginBottom: 20,
                  flex: 1,
                }}
              >
                {plan.features.map((feature, index) => (
                  <li
                    key={index}
                    className="font_family_base"
                    style={{
                      padding: "6px 0",
                      display: "flex",
                      alignItems: "center",
                      fontSize: 13,
                    }}
                  >
                    <span style={{ color: "#4CAF50", marginRight: 8 }}>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>

              <div className="center_me">
                <button
                  onClick={() => !plan.comingSoon && handleSubscribe(plan)}
                  disabled={isLoading || !!plan.comingSoon}
                  className="my-form-button-wide button-base button-3d font_family_base"
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                    backgroundImage: `url(${buttonBackground})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    color: "white",
                    fontWeight: 700,
                    opacity:
                      plan.comingSoon ||
                      (isLoading &&
                        selectedPlan ===
                          (showMonthly ? plan.idMonthly : plan.idAnnual))
                        ? 0.6
                        : 1,
                    cursor: plan.comingSoon ? "default" : "pointer",
                  }}
                >
                  {plan.comingSoon
                    ? "Coming Soon"
                    : isLoading &&
                        selectedPlan ===
                          (showMonthly ? plan.idMonthly : plan.idAnnual)
                      ? "Processing..."
                      : "Subscribe Now"}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Information */}
        {/* <div
          className="center_me"
          style={{
            marginTop: 40,
            padding: "0 20px",
            maxWidth: "800px",
            margin: "40px auto 0",
          }}
        >
          <div
            style={{
              backgroundColor: "#f9f9f9",
              padding: "20px",
              borderRadius: "8px",
              textAlign: "center",
            }}
          >
            <p className="font_family_base" style={{ marginBottom: 10 }}>
              💳 Secure payment powered by Stripe
            </p>
            <p
              className="font_family_base"
              style={{ fontSize: 14, color: "#666" }}
            >
              Cancel anytime • 30-day money-back guarantee
            </p>
          </div>

          <div style={{ marginTop: 30, textAlign: "center" }}>
            <button
              onClick={() => navigate("/settings")}
              className="font_family_base"
              style={{
                backgroundColor: "transparent",
                color: "var(--color-primary)",
                border: "1px solid var(--color-primary)",
                padding: "10px 24px",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: 14,
              }}
            >
              ← Back to Settings
            </button>
          </div>
        </div> */}

        <div className="center_me" style={{ marginTop: 30 }}>
          <button
            className="font_family_base link-text"
            onClick={handleLogout}
            type="button"
          >
            Sign out
          </button>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
